<template>
  <div class="flex flex-col h-full">
    <!-- Main Navigation Links -->
    <ul class="space-y-2">
      <!-- Admin Only Links -->
      <template v-if="me && me.is_admin">
        <!-- Home -->
        <li>
          <router-link 
            to="/dashboard" 
            class="flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative"
            :class="currentTab === 'dashboard' ? 'bg-blue-50 text-[#0d47a1]' : 'text-gray-500 hover:bg-gray-50'"
          >
            <div v-if="currentTab === 'dashboard'" class="absolute left-0 top-2 bottom-2 w-1.5 bg-[#0d47a1] rounded-r-full"></div>
            <i class="material-icons text-xl" :class="currentTab === 'dashboard' ? 'text-[#0d47a1]' : 'text-gray-400 group-hover:text-[#0d47a1]'">home</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide animate__animated animate__fadeIn">Home</span>
          </router-link>
        </li>

        <!-- Add Employee -->
        <li>
          <button 
            @click="add_user = true" 
            class="w-full flex items-center px-4 py-3 rounded-xl transition-all duration-200 group text-gray-500 hover:bg-gray-50"
          >
            <i class="material-icons text-xl text-gray-400 group-hover:text-[#0d47a1]">person_add</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide text-left animate__animated animate__fadeIn">Add Employee</span>
          </button>
        </li>

        <!-- Employees -->
        <li>
          <router-link 
            to="/employees" 
            class="flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative"
            :class="currentTab === 'employees' ? 'bg-blue-50 text-[#0d47a1]' : 'text-gray-500 hover:bg-gray-50'"
          >
            <div v-if="currentTab === 'employees'" class="absolute left-0 top-2 bottom-2 w-1.5 bg-[#0d47a1] rounded-r-full"></div>
            <i class="material-icons text-xl" :class="currentTab === 'employees' ? 'text-[#0d47a1]' : 'text-gray-400 group-hover:text-[#0d47a1]'">group</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide animate__animated animate__fadeIn">Employees</span>
          </router-link>
        </li>

        <!-- Payrolls -->
        <li>
          <router-link 
            to="/payrolls" 
            class="flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative"
            :class="currentTab === 'payrolls' ? 'bg-blue-50 text-[#0d47a1]' : 'text-gray-500 hover:bg-gray-50'"
          >
            <div v-if="currentTab === 'payrolls'" class="absolute left-0 top-2 bottom-2 w-1.5 bg-[#0d47a1] rounded-r-full"></div>
            <i class="material-icons text-xl" :class="currentTab === 'payrolls' ? 'text-[#0d47a1]' : 'text-gray-400 group-hover:text-[#0d47a1]'">calculate</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide animate__animated animate__fadeIn">Payrolls</span>
          </router-link>
        </li>

        <!-- Checks -->
        <li>
          <router-link 
            to="/checks" 
            class="flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative"
            :class="currentTab === 'checks' ? 'bg-blue-50 text-[#0d47a1]' : 'text-gray-500 hover:bg-gray-50'"
          >
            <div v-if="currentTab === 'checks'" class="absolute left-0 top-2 bottom-2 w-1.5 bg-[#0d47a1] rounded-r-full"></div>
            <i class="material-icons text-xl" :class="currentTab === 'checks' ? 'text-[#0d47a1]' : 'text-gray-400 group-hover:text-[#0d47a1]'">receipt_long</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide animate__animated animate__fadeIn">Check Batches</span>
          </router-link>
        </li>

        <!-- Reports -->
        <li>
          <router-link 
            :to="'/reports/'+(new Date()).getFullYear()" 
            class="flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative"
            :class="currentTab.includes('reports') ? 'bg-blue-50 text-[#0d47a1]' : 'text-gray-500 hover:bg-gray-50'"
          >
            <div v-if="currentTab.includes('reports')" class="absolute left-0 top-2 bottom-2 w-1.5 bg-[#0d47a1] rounded-r-full"></div>
            <i class="material-icons text-xl" :class="currentTab.includes('reports') ? 'text-[#0d47a1]' : 'text-gray-400 group-hover:text-[#0d47a1]'">assessment</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide animate__animated animate__fadeIn">Reports</span>
          </router-link>
        </li>

        <!-- Taxes & Compliance -->
        <!-- <li>
          <router-link 
            to="/taxes" 
            class="flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative"
            :class="currentTab === 'taxes' ? 'bg-blue-50 text-[#0d47a1]' : 'text-gray-500 hover:bg-gray-50'"
          >
            <div v-if="currentTab === 'taxes'" class="absolute left-0 top-2 bottom-2 w-1.5 bg-[#0d47a1] rounded-r-full"></div>
            <i class="material-icons text-xl" :class="currentTab === 'taxes' ? 'text-[#0d47a1]' : 'text-gray-400 group-hover:text-[#0d47a1]'">gavel</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide animate__animated animate__fadeIn">Taxes & Compliance</span>
          </router-link>
        </li> -->

        <!-- Settings -->
        <li>
          <router-link 
            to="/business" 
            class="flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative"
            :class="currentTab === 'business' ? 'bg-blue-50 text-[#0d47a1]' : 'text-gray-500 hover:bg-gray-50'"
          >
            <div v-if="currentTab === 'business'" class="absolute left-0 top-2 bottom-2 w-1.5 bg-[#0d47a1] rounded-r-full"></div>
            <i class="material-icons text-xl" :class="currentTab === 'business' ? 'text-[#0d47a1]' : 'text-gray-400 group-hover:text-[#0d47a1]'">business</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide animate__animated animate__fadeIn">Settings</span>
          </router-link>
        </li>
      </template>

      <!-- Employee Only Links -->
      <template v-else-if="me">
        <!-- My Profile -->
        <li>
          <router-link 
            :to="'/employee/' + me.id" 
            class="flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative"
            :class="currentTab.includes('employee') ? 'bg-blue-50 text-[#0d47a1]' : 'text-gray-500 hover:bg-gray-50'"
          >
            <div v-if="currentTab.includes('employee')" class="absolute left-0 top-2 bottom-2 w-1.5 bg-[#0d47a1] rounded-r-full"></div>
            <i class="material-icons text-xl" :class="currentTab.includes('employee') ? 'text-[#0d47a1]' : 'text-gray-400 group-hover:text-[#0d47a1]'">account_circle</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide animate__animated animate__fadeIn">My Profile</span>
          </router-link>
        </li>

        <!-- My Pay History -->
        <li>
          <router-link 
            :to="'/payhistory/' + me.id" 
            class="flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative"
            :class="currentTab.includes('payhistory') ? 'bg-blue-50 text-[#0d47a1]' : 'text-gray-500 hover:bg-gray-50'"
          >
            <div v-if="currentTab.includes('payhistory')" class="absolute left-0 top-2 bottom-2 w-1.5 bg-[#0d47a1] rounded-r-full"></div>
            <i class="material-icons text-xl" :class="currentTab.includes('payhistory') ? 'text-[#0d47a1]' : 'text-gray-400 group-hover:text-[#0d47a1]'">history</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide animate__animated animate__fadeIn">Pay History</span>
          </router-link>
        </li>

        <!-- My Timesheets -->
        <li>
          <router-link 
            :to="'/timesheet/0?emp_id=' + me.id" 
            class="flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative"
            :class="currentTab.includes('timesheet') ? 'bg-blue-50 text-[#0d47a1]' : 'text-gray-500 hover:bg-gray-50'"
          >
            <div v-if="currentTab.includes('timesheet')" class="absolute left-0 top-2 bottom-2 w-1.5 bg-[#0d47a1] rounded-r-full"></div>
            <i class="material-icons text-xl" :class="currentTab.includes('timesheet') ? 'text-[#0d47a1]' : 'text-gray-400 group-hover:text-[#0d47a1]'">timer</i>
            <span v-if="thestyle != 'width: 5em'" class="ml-4 font-bold tracking-wide animate__animated animate__fadeIn">My Timesheets</span>
          </router-link>
        </li>
      </template>
    </ul>

    <!-- Modals (Add User) -->
    <ModalComponent v-if="add_user" :submitButtonText="'Create Employee'" :title="'Register New Employee'" @close-modal="add_user = false" @submit-modal="newUser">
      <div class="py-4">
        <p class="text-sm text-gray-500 mb-6 px-1">Please provide the professional and personal details to register a new employee in the DIYPayroll system.</p>
        
        <div v-if="error" class="mb-6 bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-3 rounded-lg flex items-center">
          <i class="material-icons text-sm mr-2">error_outline</i> {{ error }}
        </div>
        <div v-if="pass_err" class="mb-6 bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-3 rounded-lg flex items-center">
          <i class="material-icons text-sm mr-2">lock_reset</i> {{ pass_err }}
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <!-- Admin Confirmation -->
          <div class="md:col-span-3 bg-gray-50 p-4 rounded-lg border border-gray-100 mb-2">
            <label class="block text-[10px] font-black text-[#0d47a1] uppercase tracking-widest mb-1">Admin Confirmation Password (*)</label>
            <input type="password" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] focus:border-transparent outline-none transition bg-white" v-model="new_employee.admin_password" placeholder="Confirm your admin access">
          </div>

          <!-- Basic Info -->
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">First Name (*)</label>
            <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.first_name">
          </div>
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Middle Name</label>
            <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.middle_name">
          </div>
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Last Name (*)</label>
            <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.last_name">
          </div>

          <!-- Account Access -->
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Username (*)</label>
            <div class="flex">
              <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-400 text-xs">@</span>
              <input type="text" class="flex-1 px-4 py-2 border border-gray-300 rounded-none rounded-r-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.username">
            </div>
          </div>
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Work Email (*)</label>
            <input type="email" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.email" placeholder="email@company.com">
          </div>
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Position / Role</label>
            <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.position">
          </div>

          <!-- Sensitive Info -->
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Date of Birth</label>
            <input type="date" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.dob">
          </div>
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Hired Date</label>
            <input type="date" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.hired">
          </div>
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">SSN (Digits Only)</label>
            <input type="password" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.ssn">
          </div>

          <!-- Contact & Address -->
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Mobile Phone</label>
            <input type="tel" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.mobile_phone">
          </div>
          <div class="md:col-span-2">
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Home Address</label>
            <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.address">
          </div>

          <!-- Location -->
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Work State</label>
            <select class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition bg-white text-sm" v-model="new_employee.state">
              <option disabled value="">Select State</option>
              <option v-for="state in states" :key="state" :value="state">{{state}}</option>
            </select>
          </div>
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">County</label>
            <select class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition bg-white text-sm" v-model="new_employee.county">
              <option disabled value="">Select County</option>
              <option v-for="county in curr_counties" :key="county" :value="county">{{county}}</option>
            </select>
          </div>
          <div class="hidden md:block"></div>

          <!-- Banking -->
          <div>
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Routing Number</label>
            <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.routing_number">
          </div>
          <div class="md:col-span-2">
            <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Bank Account Number</label>
            <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.account_number">
          </div>

          <!-- Security -->
          <div class="md:col-span-3 border-t border-gray-50 pt-4 mt-2">
            <h4 class="text-sm font-bold text-gray-800 mb-4 flex items-center">
              <i class="material-icons text-xs mr-1 text-[#0d47a1]">security</i> Employee Portal Access
            </h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Set Password (*)</label>
                <input type="password" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.password">
              </div>
              <div>
                <label class="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1">Confirm Password</label>
                <input type="password" class="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#0d47a1] outline-none transition" v-model="new_employee.pass2">
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalComponent>
  </div>
</template>

<script>
import get_api from "../service/api.js"
import base_url from "../service/base_url.js"

import ModalComponent from '../components/ModalComponent.vue'
export default {
  name: "HomeMenu",
  props:["thestyle"],
  components: {
    ModalComponent
  },
  created() {
    this.api = get_api(this.$router)
    if (localStorage.getItem("XPAYROLLaccess_token")){
        this.api.get(`${base_url}/me`).then((resp)=>{
        this.me = resp.data.data
       })
      }
  },
  data() {
    return {
      me: {},
      inc_range: false,
      isOpen: true,
      currentTab: this.$route.path.slice(1),
      add_user: false,
      add_tax: false,
      error: false,
      pass_err: false,
      tax_error: false,
      pass2: null,
      new_employee: {
        "admin_password": "",
        "username": null,
        "first_name": null,
        "last_name": null,
        "middle_name": null,
        "dob": null,
        "gender": "Female",
        "address": null,
        "email": null,
        "home_phone": null,
        "mobile_phone": null,
        "password": null,
        "emp_number": null,
        "position": null,
        "hired": null,
        "pass2": null,
        ssn: null,
        routing_number: null,
        account_number: null,
        timeout: -1,
        state: "",
        county: "",
        curr_counties: [],
        
      },
      new_tax: {
        tax_type: null,
        work_location: null, 
        percentage: null,
        name: null,
        is_employer_tax: false,
        auto_add_users: true,
        income_range1: 0,
        income_range2: 9999999999.9,
      },
      states: [
        "Maryland"
        ],
      counties: {Maryland: ['Allegany', 'Anne Arundel', 'Baltimore County', 'Calvert', 'Caroline', 'Carroll', 'Cecil', 'Charles', 'Dorchester', 'Frederick', 'Garrett', 'Harford', 'Howard', 'Kent', 'Montgomery', "Prince George's", "Queen Anne's", "St. Mary's", 'Somerset', 'Talbot', 'Washington', 'Wicomico', 'Worcester', 'Baltimore City']}
    }
  },
  methods: {
    logout(){
      localStorage.removeItem("XPAYROLLaccess_token")
      this.$store.commit('set_access_token', "")
      window.location.reload()
    },
    newUser() {
      this.registerNew()
    },
    newTax() {
      this.tax_error = ""
      let tax = Object.assign({}, this.new_tax) 
      if (!this.new_tax.name || !this.new_tax.percentage ){
        this.tax_error = "Fill in all the fields"
        return false
      }
      tax.percentage = tax.percentage/100
      this.api.post(`${base_url}/tax`, tax).then(
        () => {
          this.add_tax = false
          window.location.href = "/taxes"
        }
      ).catch((err) => {
        console.log(err)
        this.error = "Could not create tax"
      })
    },
    registerNew() {
      this.pass_err = null
      if (!this.validateEmployee(this.new_employee)) {
        return
      }
      if (this.error) {
        return
      }
      this.api.get(base_url+"/employee/username/"+this.new_employee.username).then(()=>{
        if (!this.error){
          this.error="Username already exists"
        }  
      }).catch(()=>{
        
        this.api.post(`${base_url}/register`, this.new_employee).then(
          () => {
            window.location.href = "/employees"
            this.add_user = false
          }
        ).catch((err) => {
          if (err.response.status === 405){
            this.pass_err = "Wrong admin password"
          }
          else {
            this.pass_err = "Could not create user"
          }
        })
      })
    },
    debounced(new_employee){
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {this.validateEmployee(new_employee)}, 800)
    },
    validateEmployee(new_employee) {
      this.new_employee.emp_number = Math.floor(Math.random() * (449994444444 + 1)) + 222
      if (!new_employee) {
        this.error = "Invalid data"
        return false;
      }
      if (new_employee.admin_password.length < 5) {
        this.error = "Enter admin password to create user"
        return false;
      }
      if (!new_employee.first_name || (new_employee.first_name && new_employee.first_name.length > 50)) {
        this.error = "First name must be provided and be at most 50 characters"
        return false;
      }
      if (!new_employee.last_name || (new_employee.last_name && new_employee.last_name.length > 50)) {
        this.error = "Last name must be provided and be at most 50 characters"
        return false;
      }
      if (new_employee.middle_name && new_employee.middle_name.length > 50) {
        this.error = "Middle name must be at most 50 characters"
        return false;
      }
      if (new_employee.dob && isNaN(Date.parse(new_employee.dob))) {
        this.error = "Invalid date of birth"
        return false;
      }
      if ( new_employee.email && !/^\S+@\S+\.\S+$/.test(new_employee.email)) {
        this.error = "Invalid email address"
        return false;
      }
      if (!new_employee.password || (new_employee.password && new_employee.password.length < 7)) {
        this.error = "Password must be at least 6 characters"
        return false;
      }
      if (new_employee.password !== new_employee.pass2) {
        this.error = "Passwords must match"
        return false;
      }
      if (!new_employee.state){
        this.error = "Select a state"
        return false
      }
      if (!new_employee.username) {
        this.error = "Username requiresd"
        return false;
      }
      if (new_employee.hired && isNaN(Date.parse(new_employee.hired))) {
        return false;
      }
      this.error = null
      return true;
    }
  },
  watch: {
    $route(to) {
      this.currentTab = to.path.slice(1)
    },
    new_employee: {
      handler() {
        this.debounced(this.new_employee)
        this.curr_counties = this.counties[this.new_employee.state]
      },
      deep: true
    }
  }
};
</script>
